import { ISelectOption } from "src/@types/form";

export const MY_INQUIRY_SORT_OPTIONS: ISelectOption[] = [
  {
    value: "all",
    id: "all",
    label: "All",
  },
  {
    value: "active",
    id: "active",
    label: "Active",
  },
  {
    value: "pause",
    id: "pause",
    label: "Pause",
  },
];
